import { render, staticRenderFns } from "./top-header.vue?vue&type=template&id=fa23bc8a&scoped=true&"
import script from "./top-header.vue?vue&type=script&lang=js&"
export * from "./top-header.vue?vue&type=script&lang=js&"
import style0 from "./top-header.vue?vue&type=style&index=0&id=fa23bc8a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa23bc8a",
  null
  
)

export default component.exports